// extracted by css-extract-rspack-plugin
export default {"iconStyle":"ArchivedEntityBanner-module__iconStyle___BVp4t"};